<template>
    <div class="no-xhide box">
        <v-snackbar class="snakbar-sty pt-6 d-md-none pr-6 z-i6 rounded-pill" transition="slide-x-reverse-transition"
            v-model="snackbar" timeout="4000" :value="true" :color="snackbarclr" absolute text-color="white">
            <v-icon class="mr-2" color="#fff">mdi-alert-outline</v-icon>
            {{ snackmsgbar }}
            <v-icon @click="snackbar = false" class="float-right" color="#fff">mdi-close-circle</v-icon>
        </v-snackbar>
        <v-snackbar class="snakbar-sty d-none d-md-flex pt-6 pr-6 z-i6 rounded-pill mt-10"
            transition="slide-x-reverse-transition" top right v-model="snackbar" timeout="4000" :value="true"
            :color="snackbarclr" absolute text-color="white">
            <v-icon class="mr-2" color="#fff">mdi-alert-outline</v-icon>
            {{ snackmsgbar }}
            <v-icon @click="snackbar = false" class="float-right" color="#fff">mdi-close-circle</v-icon>
        </v-snackbar>
        <div class="content">
            <div data-aos="fade-up" class="pt-md-6">
                <v-card class="elevation-0 px-16 py-10 rounded-xl pos-rlt d-none d-md-block" color="#E5EBEC">
                    <p class="fs-50 font-weight-bold mb-0"> Webinars</p>
                    <p class="headline">Intriguing webinars for the investor in you. <br> Easy to understand videos to
                        help
                        with everyday.

                    </p>

                    <!-- {{ allvideos }} -->

                    <v-autocomplete @change="videoShow(b = videois)" item-text="attributes.Title" item-value="Title"
                        append-icon="" :items="allvideos" :loading="isLoading" v-model="videois" block flat solo
                        background-color="#ffffff" clearable return-object
                        class="search-field elevation-0 mr-3 rounded-pill caption" label="Search videos" hide-details>
                        <template #prepend-inner>
                            <img src="@/assets/search-icon.svg" width="100%" class="mx-2" alt="search-icon">
                        </template>
                    </v-autocomplete>

                    <div>
                        <img class="pos-abs calc-img text-right" alt="main-bg.png" src="@/assets/Video/main-bg-web.svg"
                            width="30%" />
                    </div>
                    <div class="pos-abs learn-img">
                        <img alt="learn-bg.svg" src="@/assets/learn-bg.svg" width="172px" />
                    </div>
                </v-card>
                <v-card class="elevation-0 px-6 px-sm-8 py-10 rounded-0 text-center d-md-none" color="#E5EBEC">
                    <p class="fs-38 font-weight-bold">Webinars</p>
                    <p class="fs-18 mb-8">Intriguing webinars for the investor in you. <br> Easy to understand videos to
                        help with
                        everyday.
                    </p>

                    <v-autocomplete @change="videoShow(b)" item-text="attributes.Title" item-value="videoid"
                        append-icon="" :items="allvideos" :disabled="isLoading" :loading="isLoading" v-model="videois"
                        block flat solo background-color="#ffffff" clearable return-object
                        class="elevation-0 rounded-pill caption" label="Search videos" hide-details>
                        <template #prepend-inner>
                            <img src="@/assets/search-icon.svg" width="100%" class="mx-2" alt="search-icon">
                        </template>
                    </v-autocomplete>
                </v-card>
            </div>

            <div class="py-6 pb-md-1">
                <v-container class="px-0 px-md-16">
                    <div class="mx-auto text-md-center px-6 px-sm-8 px-md-12" v-if="detailblog.attributes">
                        <p class="mb-2 subtitle-2 font-weight-regular">
                            <span class="cursor-p" @click="toHome()">Zebu Webinar</span> → <span class="cursor-p"
                                to="/webinars">{{
                                    "All" }}</span>
                        </p>
                        <!-- {{ detailblog }} -->
                        <p class="mb-6 font-weight-bold secondary-infont fs-32 d-none d-md-block">
                            {{ detailblog.attributes ? detailblog.attributes.Title : "" }}
                        </p>
                        <!--  <p class="mb-6 font-weight-bold secondary-infont fs-28 d-md-none">
              {{ detailblog.attributes ? detailblog.attributes.blog_title : "" }}
            </p>-->
                        <v-divider></v-divider>
                        <div class="d-flex">
                            <v-card elevation="0" width="10%" class="d-none d-md-block "></v-card>
                            <v-card elevation="0" class="d-md-none" width="100%">

                                <v-row no-glutters class="py-2">
                                    <v-col cols="6" class="text-left">
                                        <p class="mb-0 subtitle-2 font-weight-regular">by Zebu</p>
                                    </v-col>
                                    <v-col cols="6" class="text-right">

                                        <p class="mb-0 subtitle-2 font-weight-regular">
                                            <span class="pt-2" v-if="blogpaid">
                                                Last Updated:
                                                {{
                                                    detailblog?.attributes?.publishedAt
                                                        ? new Date(detailblog.attributes.publishedAt)
                                                            .toDateString()
                                                            .slice(4) + ' ' +
                                                        new Date(detailblog.attributes.publishedAt)
                                                            .toLocaleString("en-US", {
                                                                hour: "numeric",
                                                                minute: "numeric",
                                                                hour12: true,
                                                            }) + ' IST'
                                                        : 'Loading...'
                                                }}

                                            </span>
                                            <span v-else class="mt-14">Last Updated: {{ detailblog.attributes
                                                ? detailblog.attributes.publishedAt : "" }} </span>

                                            <v-tooltip color="black" bottom>
                                                <template v-slot:activator="{ on, attrs }"> <v-btn class="ml-3"
                                                        @click="shareViaWebShare" v-bind="attrs" v-on="on" fab x-small
                                                        icon><v-icon
                                                            size="25">mdi-share-variant-outline</v-icon></v-btn>
                                                </template>
                                                <span>Share</span>
                                            </v-tooltip>
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-card elevation="0" class="d-none d-md-block " width="80%">

                                <v-row no-glutters class="py-2  ">
                                    <v-col cols="6" class="text-left">
                                        <p class="mb-0 subtitle-2 font-weight-regular">by Zebu</p>
                                    </v-col>
                                    <v-col cols="6" class="text-right">

                                        <p class="mb-0 subtitle-2 font-weight-regular">
                                            <span class="pt-2" v-if="blogpaid">
                                                Last Updated:
                                                {{
                                                    detailblog?.attributes?.publishedAt
                                                        ? new Date(detailblog.attributes.publishedAt)
                                                            .toDateString()
                                                            .slice(4) + ' ' +
                                                        new Date(detailblog.attributes.publishedAt)
                                                            .toLocaleString("en-US", {
                                                                hour: "numeric",
                                                                minute: "numeric",
                                                                hour12: true,
                                                            }) + ' IST'
                                                        : 'Loading...'
                                                }}

                                            </span>
                                            <span v-else class="mt-14">Last Updated: {{ detailblog.attributes
                                                ? detailblog.attributes.publishedAt : "" }} </span>

                                            <v-tooltip color="black" bottom>
                                                <template v-slot:activator="{ on, attrs }"> <v-btn class="ml-3"
                                                        @click="shareViaWebShare" v-bind="attrs" v-on="on" fab x-small
                                                        icon><v-icon
                                                            size="25">mdi-share-variant-outline</v-icon></v-btn>
                                                </template>
                                                <span>Share</span>
                                            </v-tooltip>
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-card>


                        </div>
                        <div class=" text-centre" v-if="isLoading">
                            <v-container fill-height>
                                <v-card class="elevation-0 mx-auto my-16">
                                    <v-progress-circular size="80" indeterminate color="#1e53e5"></v-progress-circular>
                                </v-card>
                            </v-container>
                        </div>
                        <v-card class="rounded-0 elevation-0" v-if="detailblog.attributes.webinortype == 'upcoming'">
                            <div v-if="detailblog.attributes">
                                <img v-if="detailblog.attributes.Image?.data?.length"
                                    :src="'https://sess.mynt.in/strapi/' + detailblog.attributes.Image.data[0]?.attributes.url"
                                    width="80%"
                                    :alt="detailblog.attributes.blog_image?.data?.length ? 'Blog image' : 'Default alt text'" />
                            </div>
                        </v-card>

                        <v-card class="rounded-0 elevation-0 text-centre" v-if="detailblog.attributes.webinortype != 'upcoming'" >
                            <div>
                        <iframe style="width:80% !important" class="rounded-lg video-dialog" type="text/html"
                            :src="`${detailblog ? convertToEmbed(detailblog.attributes.webinar_Link) : ''}`"
                            frameborder="0"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                            </div>
                        </v-card>

                        <!-- <div class="d-md-none">
                            <v-list two-line class="text-left">
                                <v-list-item>
                                    <v-list-item-avatar color="grey">
                                        <v-list-item-avatar color="white">
                                                <img  :src="require('@/assets/z logo.svg')" alt="zebu">
                                            </v-list-item-avatar>

                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold title">Zebu
                                        </v-list-item-title>
                                     
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </div> -->

                        <div class="d-flex text-centre">
                            <v-card width="10%" class="d-none d-md-block " elevation="0"></v-card>
                            <v-card width="80%" elevation="0" class="text-centre">

                                <!-- <div class="d-none d-md-block ">

                                    <v-list two-line class="text-left">
                                        <v-list-item>
                                            <v-list-item-avatar color="white">
                                                <img  :src="require('@/assets/z logo.svg')" alt="zebu">
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title class="font-weight-bold title mt-2">Zebu
                                                </v-list-item-title>
                                             
                                            </v-list-item-content>
                                            <v-spacer></v-spacer>
                                            <v-list-item-action>
                                                <v-btn large target="_blank" v-if="detailblog.attributes.webinortype == 'upcoming'"
                                                    :href="detailblog.attributes ? detailblog.attributes.webinar_Link : ''"
                                                    rounded block class="white--text text-none px-14 mt-3" color="black"
                                                    elevation="0">
                                                    Register Now
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>


                                </div> -->



                                <p class="font-weight-bold  text-left mb-0  mt-6 " style="font-size: 24px;">{{ detailblog.attributes ?
                                    detailblog.attributes.Title : ""
                                }}</p>
                                <div class="text-left fs-18 py-4 px-2 px-sm-4"
                                    v-html="detailblog.attributes ? setFormatter(detailblog.attributes.Description) : ''">
                                </div>



                                <!-- <div class="text-left">
                                <v-btn target="_blank" :href="detailblog.attributes ? detailblog.attributes.webinar_Link : ''" rounded
                                    class="white--text mt-6 text-none px-14" color="black" elevation="0">
                                    Register Now 
                                </v-btn>
                            </div> -->
                                <div>
                                    <div class="centerm d-md-none" width="100%">
                                        <v-btn target="_blank" v-if="detailblog.attributes.webinortype == 'upcoming'"
                                            :href="detailblog.attributes ? detailblog.attributes.webinar_Link : ''"
                                            class="button text-none elevation-0 white--text px-14" color="black" large
                                            rounded>Register Now</v-btn>
                                    </div>

                                    <div class="center d-none d-md-block " width="100%">
                                        <v-btn target="_blank" v-if="detailblog.attributes.webinortype == 'upcoming'"
                                            :href="detailblog.attributes ? detailblog.attributes.webinar_Link : ''"
                                            class="button text-none elevation-0 white--text px-14" color="black" large
                                            rounded>Register Now</v-btn>
                                    </div>


                                    <div class="d-none d-md-block">
                                        <v-btn target="_blank" v-if="detailblog.attributes.webinortype == 'upcoming'"
                                            :href="detailblog.attributes ? detailblog.attributes.webinar_Link : ''"
                                            large color="black" class=" white--text px-14 text-none " rounded
                                            elevation="0"> Register
                                            Now</v-btn>
                                    </div>
                                </div>
                            </v-card>
                        </div>
                        <div class="">
                            <v-btn target="_blank" v-if="detailblog.attributes.webinortype == 'upcoming'"
                                :href="detailblog.attributes ? detailblog.attributes.webinar_Link : ''" large
                                color="black" block class="d-md-none white--text mt-2 text-none px-14" rounded
                                elevation="0">
                                Register
                                Now</v-btn>
                        </div>
                        <!-- <v-divider class="mt-4"></v-divider> -->
                    </div>

                    <div v-else class="text-center">
                        <div class="mx-auto pa-16 ">
                            <img class="align-self-stretch mx-auto" width="100px"
                                :src="require('@/assets/no data folder.svg')" />
                            <h4 class="txt-999 font-weight-regular">There is no data here yet!</h4>
                        </div>
                    </div>

                </v-container>
            </div>


        </div>
    </div>
</template>

<script>
import axios from "axios";
//   import { strapi } from "../../apiurl";
//   import BlogSearch from "../Blogs/BlogSearch.vue";

export default {
    data: () => ({
        page: 1,
        pagecount: 0,
        catpagecount: 0,

        blogitems: [],

        pagename: {},

        allblogs: [],
        catblogs: [],
        allvideos: [],
        detailblog: {},
        mainblog: {},
        mainside: [],
        mainslide: [],
        imgurl: "http://192.168.5.22:1337",
        routparmsid: "",
        blogpaid: "",
        rotparmsshareid: "",
        isLoading: true,
        videois: "",
        banndialog: false,
        // showbox: true,
        signupbtn: false,
        padless: false,
        variant: 'fixed',
        snackbar: false,
        snackbarclr: "#2a2a2a",
        snackmsgbar: "",
    }),

    computed: {
        localAttrs() {
            const attrs = {}

            if (this.variant === 'default') {
                attrs.absolute = false
                attrs.fixed = false
            } else {
                attrs[this.variant] = true
            }
            return attrs
        },
    },
    mounted() {
        // window.addEventListener("scroll", this.handleScroll);
        this.getVideos()
        const routeParam = this.$route.params.title;
        const idMatch = routeParam.match(/-(\d+)$/);
        if (idMatch && idMatch[1]) {
            this.blogId = idMatch[1];
            this.blogTitle = decodeURIComponent(routeParam.replace(/-id\d+$/, '').replace(/-/g, ' '));
            this.rotparmsshareid = this.$route.params
            this.blogpaid = this.blogId
            if (this.blogpaid) {
                let catdata = [];

                import('axios').then(({ default: axios }) => {
                    const config = {
                        method: 'get',
                        maxBodyLength: Infinity,
                        // url: `https://sess.mynt.in/strapi/blogs/${queryId}`,
                        url: `https://sess.mynt.in/strapi/zebu-schools/${this.blogpaid}?populate=*`,
                        headers: {},
                    };
                    axios.request(config)
                        .then((response) => {
                            const errordata = response.data
                            const apiData = response.data?.data;
                            this.isLoading = false
                            if (apiData) {
                                for (let v = 0; v < apiData.length; v++) {
                                    apiData[v].img = `${"https://sess.mynt.in/strapi"}${apiData[v].attributes.Image.data[0].attributes.url}`;
                                    // data[v]['isdate'] = `${new Date(data[v].uploadtime).toDateString().slice(3)} ${new Date(data[v].uploadtime).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })} IST`;
                                    // data[v]['ago'] = axiosThis.differentDate(data[v].attributes.publishedAt);
                                    // data[v]['view'] = axiosThis.differentView(Number(data[v].viewCount));
                                    catdata.push(apiData[v]);
                                }
                                this.detailblog = apiData;
                                // console.log(";;@@@@@@@@@;;;", this.detailblog);
                            } else {
                                if (errordata.error.message == 'Not Found') {
                                    this.$router.push("/webinars");
                                    this.isLoading = false

                                }

                            }
                        })
                        .catch((error) => {
                            console.error("Error fetching data from API:", error);
                            this.isLoading = false
                            this.snackbar = true;
                            this.snackbarclr = "error";
                            this.snackmsgbar = error;

                        });
                });
            } else {
                this.$router.push("/webinars");
                this.isLoading = false

            }
        }
        else {
            this.$router.push("/webinars");
            this.isLoading = false


        }


    },

    methods: {
        convertToEmbed(link) {
            // console.log("link", link);

            let videoId = '';

            if (link.includes('youtu.be/')) {
                videoId = link.split('youtu.be/')[1]?.split('?')[0];
            } else if (link.includes('youtube.com/watch')) {
                videoId = link.split('v=')[1]?.split('&')[0];
            }

            // console.log("videoId", videoId);

            return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
        },
        // handleScroll(event) {
        //     console.log("Scrolled inside container:", event.target.scrollTop);
        // },
        searchdata() {
            const routeParam = this.$route.params.title;
            const idMatch = routeParam.match(/-(\d+)$/);
            if (idMatch && idMatch[1]) {
                this.blogId = idMatch[1];
                this.blogTitle = decodeURIComponent(routeParam.replace(/-id\d+$/, '').replace(/-/g, ' '));
                this.rotparmsshareid = this.$route.params
                this.blogpaid = this.blogId
                if (this.blogpaid) {
                    let catdata = [];

                    import('axios').then(({ default: axios }) => {
                        const config = {
                            method: 'get',
                            maxBodyLength: Infinity,
                            // url: `https://sess.mynt.in/strapi/blogs/${queryId}`,
                            url: `https://sess.mynt.in/strapi/zebu-schools/${this.blogpaid}?populate=*`,
                            headers: {},
                        };
                        axios.request(config)
                            .then((response) => {
                                const errordata = response.data
                                const apiData = response.data?.data;
                                if (apiData) {
                                    for (let v = 0; v < apiData.length; v++) {
                                        apiData[v].img = `${"https://sess.mynt.in/strapi"}${apiData[v].attributes.Image.data[0].attributes.url}`;
                                        // data[v]['isdate'] = `${new Date(data[v].uploadtime).toDateString().slice(3)} ${new Date(data[v].uploadtime).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })} IST`;
                                        // data[v]['ago'] = axiosThis.differentDate(data[v].attributes.publishedAt);
                                        // data[v]['view'] = axiosThis.differentView(Number(data[v].viewCount));
                                        catdata.push(apiData[v]);
                                    }
                                    this.detailblog = apiData;
                                    // console.log(";;@@@@@@@@@;;;", this.detailblog);
                                } else {
                                    if (errordata.error.message == 'Not Found') {
                                        this.$router.push("/blogs");

                                    }

                                }
                            })
                            .catch((error) => {
                                console.error("Error fetching data from API:", error);

                            });
                    });
                } else {
                    this.$router.push("/webinar");
                }
            }
            else {
                this.$router.push("/webinar");

            }

        },
        videoShow(b) {
            if (b) {
                // b.attributes['pagename'] = this.pagename;
                // this.$router.push({ name: 'single blog', params: b });
                b.attributes['pagename'] = b;
                const formattedTitle = b.attributes.Title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '');
                this.$router.push(`/webinar/${formattedTitle}-${b.id}`);
                this.searchdata()
            }
        },
        getVideos() {
            this.isLoading = true;
            this.allvideos = []
            let config = {
                method: 'post',
                url: `https://sess.mynt.in/strapi/zebu-schools?populate=*`,
            };

            let axiosThis = this;
            axios.request(config)
                .then((response) => {
                    if (response.data.data) {
                        let data = response.data.data
                        for (let v = 0; v < data.length; v++) {
                            // data[v].attributes["img"] = `${"https://sess.mynt.in/strapi"}${data[v].attributes.Image.data[0].attributes.url}`;
                            // data[v]['isdate'] = `${new Date(data[v].uploadtime).toDateString().slice(3)} ${new Date(data[v].uploadtime).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })} IST`;
                            // data[v]['ago'] = axiosThis.differentDate(data[v].attributes.publishedAt);
                            // data[v]['view'] = axiosThis.differentView(Number(data[v].viewCount));
                            axiosThis.allvideos.push(data[v]);
                        }
                    }
                    // console.log(axiosThis.allvideos);

                    axiosThis.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setFormatter(para) {
            const formattedData = para
                // Replace headings
                .replace(/^# (.*?)$/gm, "<h1>$1</h1>")
                .replace(/^## (.*?)$/gm, "<h2>$1</h2>")
                .replace(/^### (.*?)$/gm, "<h3>$1</h3>")
                .replace(/^#### (.*?)$/gm, "<h4>$1</h4>")
                .replace(/^##### (.*?)$/gm, "<h5>$1</h5>")
                .replace(/^###### (.*?)$/gm, "<h6>$1</h6>")
                // Replace blockquotes (lines starting with ">")
                .replace(/^> (.*?)$/gm, "<blockquote>$1</blockquote>")
                // Replace inline bold text (double asterisks or double underscores)
                .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
                .replace(/__(.*?)__/g, "<strong>$1</strong>")
                // Replace inline italic text (single asterisk or single underscore)
                .replace(/\*(.*?)\*/g, "<em>$1</em>")
                .replace(/_(.*?)_/g, "<em>$1</em>")
                // Replace inline underlined text
                .replace(/<u>(.*?)<\/u>/g, '<span style="text-decoration: underline;">$1</span>')
                // Replace inline code blocks (`code`)
                .replace(/`(.*?)`/g, "<code>$1</code>")
                // Replace links ([text](url))
                .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>')
                // Handle unordered lists (lines starting with "- " or "* ")
                .replace(/^[-*] (.*?)$/gm, "<ul><li>$1</li></ul>")
                // Handle ordered lists (lines starting with number + ". ")
                // .replace(/^\d+\.\s*(.*?)$/gm, "<ol><li>$1</li></ol>")
                // Replace double line breaks with closing and opening paragraph tags
                .replace(/\n\s*\n/g, "</p><p>")
                // Wrap the entire text in opening and closing paragraph tags
                .replace(/^(?!<h1>|<h4>|<blockquote>|<ul>|<ol>|<\/p>|<\/h1>|<\/h4>|<\/blockquote>)(.+)$/gm, "<p>$1</p>");

            return formattedData;
        },
        scrollBehavior() {
            window.scrollTo(0, 0);
        },
        activePage(i) {
            this.$router.push({ name: "blog category", params: i });
        },


        toHome() {
            this.$router.push("/webinars");
        },
        setDetailsForComponent() {
            this.detailblog = {};
            let b = JSON.parse(localStorage.getItem("50bf"));
            this.pagename = b.attributes.pagename;
            this.detailblog = b;
            this.getCategorie();
            this.scrollBehavior();
        },

        shareViaWebShare() {
            const formattedTitle = this.detailblog.attributes.Title
                .replace(/\s+/g, '-')
                .replace(/[^a-zA-Z0-9-]/g, '');

            const blogUrl = `${window.location.origin}/webinar/${formattedTitle}-${this.detailblog.id}`;

            // Use Web Share API
            navigator.share({
                title: "Zebu",
                text: "Zebu offers trading and investment opportunities. Create an account right away.",
                url: blogUrl,
            }).catch((error) => {
                console.error('Error using Web Share API:', error);
            });
        },

    },
};
</script>

<style>
.center {
    margin: 0;
    position: fixed;
    top: 100%;
    left: 56%;
    /* width: 80% !important; */
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.centerm {
    margin: 0;
    position: fixed;
    top: 100%;
    left: 93%;
    /* width: 80% !important; */
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.content {
    overflow: auto;
    width: 100%;
    height: 100%;
}

.button {
    position: fixed;
    /* z-index: 8; */
    bottom: 0.5rem;
    right: 0.5rem;
    width: 344px;
}
</style>
<!-- 




-->